exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-btn-wrapper {\n  position: relative;\n  overflow: hidden;\n  display: inline-block; }\n\n.upload-btn-wrapper input[type='file'] {\n  font-size: 13px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  height: 38px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Common/Form/fileUploader.scss
// module id = 1457
// module chunks = 1